import { BaseApiConstants as BaseConstants } from '../base-api/base-api.constants.js';
import { allETFsQuery } from './ivs-api.queries.js';
/**
 * Represents the supported queries
 */
export const QueryType = {
    ALL: 'ALL',
    ETF: 'ETF',
};
const APIKEY_DEV = 'key-placeholder';
const ENDPOINT_SUFFIX = '/investment-vehicle-svc/service/graphql';
const ENDPOINT_DEV = new URL(ENDPOINT_SUFFIX, BaseConstants.DOMAIN_DEV).toString();
const defaultClientOptions = {
    ...BaseConstants.CLIENT_DEFAULT_OPTS,
    headers: {
        apikey: APIKEY_DEV,
        'Content-Type': 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    name: 'ivs-api-service',
    uri: ENDPOINT_DEV,
    typeDefs: allETFsQuery,
};
export const Constants = {
    CLIENT_DEFAULT_OPTS: defaultClientOptions,
    ENDPOINT_SUFFIX,
    ENDPOINT_DEV,
    ENDPOINT_STAGE: new URL(ENDPOINT_SUFFIX, BaseConstants.DOMAIN_STAGE).toString(),
    ENDPOINT_PROD: new URL(ENDPOINT_SUFFIX, BaseConstants.DOMAIN_PROD).toString(),
    APIKEY_DEV,
    QUERY_TYPES: Object.keys(QueryType),
    LOG_ERROR_PREFIX: `Error: ${defaultClientOptions.name} processResponse: `,
};
//# sourceMappingURL=ivs-api.constants.js.map